import { Controller } from "@hotwired/stimulus"

// Tiny filter controller for list items with [data-filter-state] attributes.
// Clicking a pill toggles filtering; clicking the active pill clears it.
export default class extends Controller {
  static targets = ["pill"]

  declare pillTargets: HTMLElement[]

  toggle(event: Event) {
    const pill = (event.currentTarget as HTMLElement)
    const state = pill.dataset.listFilterStateParam
    const current = this.element.getAttribute("data-active-filter")

    if (current === state) {
      this.element.removeAttribute("data-active-filter")
    } else {
      this.element.setAttribute("data-active-filter", state!)
    }

    this.pillTargets.forEach(p => {
      p.classList.toggle("active", p.dataset.listFilterStateParam === this.element.getAttribute("data-active-filter"))
    })
  }
}

